// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eab326c6","453":"7d673276","455":"cf61d5aa","977":"f46629bb"}[chunkId] + ".chunk.js";
};